import { render, staticRenderFns } from "./QRScanner.vue?vue&type=template&id=48b74534&scoped=true&"
import script from "./QRScanner.vue?vue&type=script&lang=js&"
export * from "./QRScanner.vue?vue&type=script&lang=js&"
import style0 from "./QRScanner.vue?vue&type=style&index=0&id=48b74534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b74534",
  null
  
)

export default component.exports